
import React from "react";
import { Box, Container, Typography, Grid, Paper } from "@mui/material";
import {
  FiHome,
  FiCheckCircle,
  FiShield,
  FiSearch,
} from "react-icons/fi";

const features = [
  {
    icon: <FiHome />,
    title: "Find Your Dream Home",
    description:
      "Explore a wide range of residential properties, apartments, and houses to find the perfect place for you and your family.",
  },
  {
    icon: <FiCheckCircle />,
    title: "Verified Properties",
    description:
      "Discover carefully reviewed property listings with reliable information to help you make confident real estate decisions.",
  },
  {
    icon: <FiShield />,
    title: "Trusted Property Listings",
    description:
      "Browse property options with greater confidence. We aim to make your home-buying and renting journey simple and transparent.",
  },
  {
    icon: <FiSearch />,
    title: "Easy Property Search",
    description:
      "Find properties that fit your budget, location, and lifestyle with an easy and convenient property discovery experience.",
  },
];

const GharnMakaanFeatures = () => {
  return (
    <Box
      component="section"
      sx={{
        py: { xs: 6, md: 8 },
        px: { xs: 2, sm: 3 },
        bgcolor: "background.paper",
      }}
    >
      <Container maxWidth="xl">
        {/* Section Heading */}
        <Box
          sx={{
            textAlign: "center",
            maxWidth: 800,
            mx: "auto",
            mb: { xs: 5, md: 7 },
          }}
        >
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
              fontWeight: 800,
              lineHeight: 1.15,
              color: "text.primary",
              letterSpacing: "-1px",
            }}
          >
            Find Your Perfect Home with
          </Typography>

          <Typography
            component="span"
            sx={{
              display: "block",
              fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
              fontWeight: 800,
              lineHeight: 1.15,
              color: "primary.main",
              letterSpacing: "-1px",
            }}
          >
            GharNmakaan
          </Typography>

          <Typography
            sx={{
              mt: 2,
              fontSize: { xs: "0.95rem", md: "1.05rem" },
              lineHeight: 1.8,
              color: "text.secondary",
            }}
          >
            Discover a better way to explore properties, find your dream
            home, and make confident real estate decisions with GharnMakaan.
          </Typography>
        </Box>

        {/* Feature Cards */}
        <Grid container spacing={2.5}>
          {features.map((feature) => (
            <Grid item xs={12} sm={6} lg={3} key={feature.title}>
              <Paper
                elevation={0}
                sx={{
                  height: "100%",
                  boxSizing: "border-box",
                  p: 2.5,
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: "20px",
                  bgcolor: "background.paper",
                  boxShadow: "0 1px 3px rgba(15, 23, 42, 0.08)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    borderColor: "primary.main",
                    boxShadow: "0 10px 28px rgba(15, 23, 42, 0.09)",
                  },
                }}
              >
                {/* Icon */}
                <Box
                  sx={{
                    width: 50,
                    height: 50,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2.5,
                    borderRadius: "15px",
                    bgcolor: "rgba(244, 162, 97, 0.16)",
                    color: "primary.main",
                    fontSize: 25,
                    "& svg": {
                      strokeWidth: 1.8,
                    },
                  }}
                >
                  {feature.icon}
                </Box>

                {/* Title */}
                <Typography
                  component="h3"
                  sx={{
                    fontSize: "1.05rem",
                    fontWeight: 700,
                    color: "text.primary",
                    mb: 1,
                    lineHeight: 1.5,
                  }}
                >
                  {feature.title}
                </Typography>

                {/* Description */}
                <Typography
                  sx={{
                    fontSize: "0.875rem",
                    lineHeight: 1.8,
                    color: "text.secondary",
                  }}
                >
                  {feature.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default GharnMakaanFeatures;
